<ion-content>
  <div class="informations-complementary">
    <div class="block map" [class.map-hidden]="!mapVisible">
      <div class="header-button-map">
        <ion-buttons slot="start">
          <ion-menu-button autoHide="false"></ion-menu-button>
        </ion-buttons>
      </div>
      <app-dashboard-map class="actual-map"></app-dashboard-map>
    </div>
    <div class="block dashboard-card">
      <div class="dashboard-card__header">
        <div class="welcome-section">
          <span class="dashboard-card__brand">GoSpread</span>
          <h3 class="title" *ngIf="user">Hello, {{ user.name }} 👋</h3>
        </div>
      </div>

      <div class="wanna-go-btn" (click)="goToPage('call', 'call-driver')">
        <ion-icon name="search-outline"></ion-icon>
        <span>Where do you want to go?</span>
      </div>
      <swiper-container
        class="action-swiper"
        [slidesPerView]="3"
        [spaceBetween]="8"
        [modules]="swiperModules"
      >
        <swiper-slide>
          <div class="option-container" (click)="generateQrCode()">
            <div class="image-container">
              <ion-img src="assets/qr-code.png" class="dashboard-icon" />
            </div>
            <div class="image-title"><p>QR Code</p></div>
            <div class="value"><p>Generate</p></div>
          </div>
        </swiper-slide>

        <swiper-slide>
          <div class="option-container" (click)="goToPage('', 'guest')">
            <div class="image-container">
              <ion-img src="assets/user2.png" class="dashboard-icon" />
            </div>
            <div class="image-title"><p>Guest link</p></div>
            <div class="value"><p>Share</p></div>
          </div>
        </swiper-slide>

        <swiper-slide>
          <div
            class="option-container"
            (click)="goToPage('call', 'seller-registration')"
          >
            <div class="image-container">
              <ion-img src="assets/spread.png" class="dashboard-icon" />
            </div>
            <div class="image-title"><p>Spread</p></div>
            <div class="value"><p>{{referCount}}</p></div>
          </div>
        </swiper-slide>

        <swiper-slide>
          <div
            class="option-container"
            (click)="goToPage('call', 'call-driver')"
          >
            <div class="image-container">
              <ion-img
                src="assets/images/avatar-motorista-volante.png"
                class="dashboard-icon"
              />
            </div>
            <div class="image-title"><p>Trips</p></div>
            <div class="value">
              <p *ngIf="earningsTotais.semanaAtualCorrida">
                $ {{earningsTotais.semanaAtualCorrida.saldoSemanal}}
              </p>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide>
          <div
            class="option-container"
            (click)="goToPage('call', 'restaurants-booking')"
          >
            <div class="image-container">
              <ion-img src="assets/restaurant.png" class="dashboard-icon" />
            </div>
            <div class="image-title"><p>Services</p></div>
            <div class="value">
              <p *ngIf="earningsTotais.semanaAtualRestaurante">
                $ {{earningsTotais.semanaAtualRestaurante.totalRecebido}}
              </p>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide>
          <div
            class="option-container"
            (click)="goToPage('', 'balance-driver')"
          >
            <div class="image-container">
              <ion-img src="assets/earnings.png" class="dashboard-icon" />
            </div>
            <div class="image-title"><p>Earnings</p></div>
            <div class="value">
              <p
                *ngIf="earningsTotais.semanaAtualCorrida && earningsTotais.semanaAtualRestaurante"
              >
                $ {{earningsTotais.semanaAtualCorrida.saldoSemanal +
                earningsTotais.semanaAtualRestaurante.totalRecebido}}
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper-container>
      <div class="dashboard-banner">
        <ion-img *ngIf="dashboard.banner" [src]="dashboard.banner" />
        <!-- <ion-img *ngIf="dashboard.banner" src="assets/images/banner-test-2.jpg" /> -->
      </div>
      <div class="dashboard-info">
        <p>{{dashboard.texto}}</p>
      </div>
    </div>
  </div>
  <app-modal-component *ngIf="modalLink" (stateOpen)="modalLink = $event">
    <ion-img src="assets/logo-qrcode.png" class="brand-footer" alt="" />
    <div class="container">
      <div class="row" style="margin-left: initial; flex-direction: column">
        <div>
          <qrcode
            [qrdata]="linkShare"
            [width]="256"
            [errorCorrectionLevel]="'H'"
          ></qrcode>
        </div>
        <div>
          <p style="text-align: center">
            This is your personal QR code, it benefits both you and your
            referrals. Everyone who accesses the app using this QR code will
            have numerous benefits such as discounts, reservations, exclusive
            services, and much more. This will increase your commissions, so
            make sure to share it! Use it on your social media, flayers,
            banners, and in any media you deem appropriate. Spread it!
          </p>
        </div>
      </div>
    </div>
  </app-modal-component>
</ion-content>
